import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { QUIZ_FEATURE_KEY } from './keys';
import { quizReducer } from './reducers/quizes.reducer';
import { QuizEffects } from './effects/quizes.effects';

export const quizStoreProviders = [provideState(QUIZ_FEATURE_KEY, quizReducer), provideEffects(QuizEffects)];

export { QuizFacade } from './facades/quizes.facade';
export { quizLoaded } from './guards/loaded.guard';
export { quizCleanup } from './guards/cleanup.guard';
export { Quiz, Question, Option } from './models';
export { quizActions } from './actions/quizes.actions';
